import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';

interface ConfirmRemoveDialogProps {
  open: boolean;
  loading: boolean;
  networkCode: string | null;
  onClose: () => void;
  onConfirm: () => void;
}

// Диалог подтверждения удаления сети из интеграции
export const ConfirmRemoveDialog: React.FC<ConfirmRemoveDialogProps> = ({
  open,
  loading,
  networkCode,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('IntegrationsPage.ConfirmRemove.TITLE')}</DialogTitle>
      <DialogContent>
        {t('IntegrationsPage.ConfirmRemove.DESCRIPTION', {
          code: networkCode || '',
        })}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          {t('IntegrationsPage.Common.CANCEL')}
        </Button>
        <Button
          color="error"
          variant="contained"
          disabled={loading || !networkCode}
          onClick={onConfirm}
        >
          {t('IntegrationsPage.ConfirmRemove.CONFIRM')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmRemoveDialog;
